import { RootNode } from './RootNode';
import {
  APILayerGroup,
  Node,
  NodeStatus,
  TreeContext,
  TreeServices,
} from './types';
import { LayerNode } from './LayerNode';
import { computed, makeObservable, observable, runInAction } from 'mobx';
import {
  buildNodeFromApiLayer,
  findLayerGroupNode,
  findLayersNode,
  findTableLayersNode,
} from './utils';
import { TableLayerNode } from './TableLayerNode';

export class LayerGroupNode implements Node {
  readonly parent: LayerGroupNode | RootNode;
  @observable private _children: (
    | LayerGroupNode
    | LayerNode
    | TableLayerNode
  )[] = [];
  @observable private _childrenStatus = NodeStatus.notLoaded;
  @observable private _error: string | undefined = undefined;
  private _layer: APILayerGroup;
  private _services: TreeServices;
  private _context: TreeContext;

  constructor(
    layer: APILayerGroup,
    parent: LayerGroupNode | RootNode,
    context: TreeContext,
    services: TreeServices,
  ) {
    this._services = services;
    this._context = context;
    this._layer = layer;
    this.parent = parent;
    makeObservable(this);
  }

  @computed get layer(): APILayerGroup {
    return JSON.parse(JSON.stringify(this._layer));
  }

  @computed get name() {
    return this._layer.layer_name;
  }

  @computed get description() {
    return this._layer.description;
  }

  @computed get imageSrc(): string | undefined {
    return this._layer?.icon;
  }

  @computed get children() {
    return [...this._children];
  }

  @computed get childrenLayerGroup(): LayerGroupNode[] {
    return findLayerGroupNode(this._children);
  }

  @computed get childrenLayer(): LayerNode[] {
    return findLayersNode(this._children);
  }

  @computed get childrenTableLayer(): TableLayerNode[] {
    return findTableLayersNode(this._children);
  }

  @computed get childrenStatus() {
    return this._childrenStatus;
  }

  @computed get error() {
    return this._error;
  }

  async load() {
    this._childrenStatus = NodeStatus.loading;
    this._error = undefined;

    try {
      const response = await this._services.map.apiLayersList(1, 0, {
        query: {
          group: this.layer.layer_name,
          _order: 'description',
        },
      });

      const layers = response.data.results;
      const nodes = layers.map((layer) =>
        buildNodeFromApiLayer(layer, this, this._context, this._services),
      );

      runInAction(() => {
        this._children = nodes;
        this._childrenStatus = NodeStatus.loaded;
      });
    } catch (e) {
      runInAction(() => {
        this._childrenStatus = NodeStatus.notLoaded;
        this._error = 'Не удалось загрузить слои';
      });
    }
  }
}
